export default {
  //
  // ============================================================================
  // LOGIN HEADER - Login Page Header Section
  // ============================================================================
  //
  loginHeader: {
    labSubtitle: "Laboratory Information System",
    defaultLabName: "Laboratory Portal",
    defaultLogoAlt: "Laboratory Logo",
    signIn: "Sign In",
    openMenu: "Open menu",
    language_section: {
      title: "Select Language",

      languages: {
        en: "English",
        bg: "Bulgarian",
        mk: "Macedonian",
      },
    },
  },

  //
  // ============================================================================
  // LOGIN FORM - Login Form Section
  // ============================================================================
  //
  loginForm: {
    title: "Web Portal for online results",
    description:
      "Download your results online, without wasting time on repeated visits. For doctors and medical partners - special features for tracking patients.",
    loginButtonText: "Sign In",
    agreeTerms: "I agree to the",
    termsOfUse: "Terms of Use",
    termsOfUseTooltip: "Click to read our Terms of Use",
    termsDialogTitle: "Terms of Use",
    termsDialogOk: "OK",
    termsLoadingError: "Failed to load terms of use. Please try again.",
    termsLoadingText: "Loading terms of use...",
    scrollToBottom: "Please scroll to the bottom to continue",
    scrollToBottomButton: "Scroll to Bottom",
  },

  //
  // ============================================================================
  // LOGIN FOOTER - Login Page Footer Section
  // ============================================================================
  //
  loginFooter: {
    // === General Information ===
    subtitle: "Laboratory Information System",
    poweredBy: "Powered by",
    description: "Modern LIMS platform for managing laboratory processes, tests, and results.",
    disclaimer:
      "The system is accessible only to authorized users. For access credentials, contact the laboratory.",

    // === Resources Section ===
    resources: "Medical Services",
    labTests: "Tests",
    labTestsTooltip: "View laboratory test catalog",
    pricing: "Pricing",
    pricingTooltip: "View pricing and packages",
    covidTesting: "COVID-19",
    covidTestingTooltip: "COVID-19 testing services",
    documentation: "Documentation",
    documentationTooltip: "View documentation",

    // === Product Information ===
    lisILab: "LIMS iLab",
    limsILabTooltip: "LIMS iLab - Laboratory Information Management System",

    // === Contact Section ===
    connect: "Contact Us",
    locationDetails: "Sofia, 1 Vitosha Blvd",
    locationDetailsTooltip: "Visit Us",
    phone: "Phone",
    phoneNumber: "+359 2 XXX XXXX",
    phoneTooltip: "Give us a call",
    email: "Email",
    emailAddress: "info-precisio.bg",
    emailTooltip: "Send us an email",
    workingHoursDetails: "Mon-Fri: 07:30-19:00",
    workingHoursTooltip: "Laboratory working hours",

    // === Company & Copyright ===
    skywareGroup: "SKYWARE Group",
    skywareGroupUrl: "https://skyware-group.com",
    skywareGroupTooltip: "Visit SKYWARE Group website",
    github: "GitHub",
    nuget: "NuGet",
    copyrightPrefix: "Copyright ©",
    versionLabel: "version",

    // === Quick Contact ===
    quickPhone: "Phone",
    quickPhoneTooltip: "Call us for inquiries",
    quickEmail: "Email",
    quickEmailTooltip: "Send us an email",
    quickLocation: "Visit",
    quickLocationTooltip: "Find our location",
  },
};
